import { css, styled } from 'app/pages/request-single-page/components-v4/theme';

export const StyledMobileHeader = styled.div<{ $visible: boolean }>`
  ${({ theme, $visible }) => css`
    padding: ${theme.spacings.base};
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacings.xs};
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    opacity: ${$visible ? '1' : '0'};
    visibility: ${$visible ? 'visibile' : 'hidden'};
    transition-duration: ${theme.tokens.animation.duration.base};
    transition-timing-function: ${theme.tokens.animation.easing.decelerate};
  `}
`;

export const MobileControls = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacings.base};
    width: 100%;
  `}
`;
